module.exports = __webpack_public_path__ + "static/media/chrisOne.410cc813.jpg";